import React, { Component } from 'react'
import {isBrowser} from 'react-device-detect';

export default class Animation extends Component {
  render() {
    if(isBrowser) {
      return (
        <>
        <div className="animation-float animation-ease animation-infinite animation-fill-forwards animation-6s z-0 h-10 w-10 absolute top-7/12 left-2/12 border-4 border-orange rounded-full"></div>
        <div className="animation-float animation-ease animation-infinite animation-fill-forwards animation-4s animation-delay-1s z-0 h-8 w-8 absolute top-2/12 left-8/12 border-4 border-orange rounded-full"></div>
        <div className="animation-float animation-ease animation-infinite animation-fill-forwards animation-10s animation-delay-2s z-0 h-2 w-2 absolute bottom-2/12 right-2/12 border-4 border-orange rounded-full"></div>
        <div className="animation-float animation-ease animation-infinite animation-fill-forwards animation-3s z-0 h-6 w-6 absolute top-1/2 left-1/4 bg-orange rounded-full"></div>
        <div className="animation-float animation-ease animation-infinite animation-fill-forwards animation-10s z-0 h-60 w-60 opacity-25 absolute bottom-0 border-40 border-orange rounded-full"></div>
        </>
      )
    } else {
      return null
    }
  }
}
